import $ from "jquery";

function pushToDataLayer(
  eventValue: string,
  eventCategoryValue: string,
  eventActionValue: string,
  eventLabelValue: string,
  additionalLabel: string,
  additionalValue: string
) {
  window.dataLayer.push({
    event: eventValue,
    eventCategory: eventCategoryValue,
    eventAction: eventActionValue,
    eventLabel: eventLabelValue,
    additionalLabel: additionalValue,
  });
}

function init(): void {
  const $links = $(".nav__list-item-link");
  $links.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "navigation",
        "navigation_link_click",
        "top_navigation",
        e.target.textContent,
        "top_navigation",
        e.target.textContent
      );
    }
  });

  const $subLinks = $(".nav__list-item .nav__flyout-description--with-btn > a");
  $subLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "navigation",
        "navigation_link_click",
        "_navigation",
        e.target.textContent,
        "top_navigation",
        e.target.textContent
      );
    }
  });

  const $emailLinks = $('a[href^="mailto:"]');
  $emailLinks.click((e) => {
    if (window.dataLayer) {
      const email = e.target.href.replace("mailto:", "");
      pushToDataLayer("contact_us", "contact_us_email_click", "email", email, "email", email);
    }
  });

  const $footerExtLinks = $(".footer .footer__main-nav-list-item-link");
  $footerExtLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "external_link",
        e.target.textContent + "_click",
        e.target.href,
        "undefined",
        "external_link",
        e.target.textContent
      );
    }
  });

  const $spotlightLinks = $(".spotlight-card .spotlight-card__card .spotlight-card__link");
  $spotlightLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "cta ",
        e.target.pathname,
        "spotlight_cta_button_click",
        e.target.textContent,
        "spotlightcard",
        e.target.innerText
      );
    }
  });

  const $promoCardLinks = $(".promo-card .promo-card__btn");
  $promoCardLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "cta ",
        e.target.pathname,
        "promocard_cta_button_click",
        e.target.innerText,
        "button",
        e.target.innerText
      );
    }
  });

  const $topHatLinks = $(".top-hat .top-hat__links .top-hat__links-link");
  $topHatLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer(
        "user_type ",
        "user_type_" + e.target.innerText,
        "top_hat_link_click",
        e.target.innerText,
        "user_type",
        e.target.innerText
      );
    }
  });
}

export default { init };
